import { render, staticRenderFns } from "./userAgreement2.0.vue?vue&type=template&id=16b681e7&scoped=true&"
import script from "./userAgreement2.0.vue?vue&type=script&lang=js&"
export * from "./userAgreement2.0.vue?vue&type=script&lang=js&"
import style0 from "./userAgreement2.0.vue?vue&type=style&index=0&id=16b681e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b681e7",
  null
  
)

export default component.exports